import React from "react";
import styles from "./QuotationDetailTable.module.scss";

const ACCENT_CLASSES = {
  red: styles.accentRed,
  blue: styles.accentBlue,
  orange: styles.accentOrange,
  green: styles.accentGreen,
  gray: styles.accentGray,
};

const DetailSectionCard = ({
  title,
  icon,
  accent = "gray",
  children,
  ...rest
}) => {
  return (
    <div
      className={`${styles.sectionCard} ${
        ACCENT_CLASSES[accent] || ACCENT_CLASSES.gray
      }`}
      {...rest}
    >
      <div className={styles.sectionHead}>
        <span className={styles.sectionIcon}>
          <i className={`fa fa-${icon}`} />
        </span>
        <span className={styles.sectionTitle}>{title}</span>
      </div>
      {children}
    </div>
  );
};

export default DetailSectionCard;
